@if(step=='start'){
<div class="p-3">
  <label class="mb-2 d-block"><strong>Handoff mode</strong></label>
  <p-selectButton
    [options]="handoffOptions"
    [(ngModel)]="handoff"
    optionLabel="label"
    optionValue="value"
    styleClass="w-100 handoff-mode-select"
    [style]="{ width: '100%' }"
  ></p-selectButton>
  <div class="mt-3 p-2" style="background: #f8f9fa; border-radius: 6px;">
    <small>{{ selectedHandoffTip }}</small>
  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="Cancel" severity="secondary" (onClick)="onCancel()" />
  <p-button label="Next" class="ms-3" (onClick)="onNextOnHandoff()" />
</div>
}
@if(step=='staffSelectAndSign' || step=='temporarySelectAndSign'){
<div class="flex justify-content-end gap-2 p-3">
  <div class="w-100">
    @if(step=='staffSelectAndSign'){
      Select the next responsible staff and collect their signature to complete this handoff.
    } @else {
      Select the staff responsible for this temporary handoff and collect their signature.
    }
    <br>
    <br>
    <label for="selectedStaff">Staff</label>
    <p-dropdown
      id="selectedStaff"
      [options]="availableStaff"
      optionLabel="FullName"
      [(ngModel)]="selectedStaff"
      [filter]="true"
      filterBy="FullName"
      [resetFilterOnHide]="true"
      appendTo="body"
      styleClass="w-100"
      placeholder="Select staff"
    />
    <br>
    <br>
    <label>Signature</label>
    <signature-pad class="border-sign" [options]="signaturePadOptions"></signature-pad>
  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="Back" severity="secondary" (onClick)="step='start'" />
  <p-button [label]="step=='temporarySelectAndSign' ? 'Start Temporary Handoff' : 'End Session'" class="ms-3" (onClick)="onSubmit()" />
</div>
}
@if(step=='nextGuardian'){
<div class="flex justify-content-end gap-2 p-3">
  <div>
    This client's sessions are over for the day. Is the parent there for pickup?
  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="No" severity="secondary" (onClick)="onNoOnGuardianHandoff()" />
  <p-button label="Yes" class="ms-3" (onClick)="onYesOnGuardianHandoff()" />
</div>
}
@if(step=='NoOnGuardianHandoff'){
<div class="flex justify-content-end gap-2 p-3">
  <div>
    Would you like to end your session without a parent signature?<br>
    Explain:<br> <textarea [(ngModel)]="explain" class="w-100"></textarea>
  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="Back to session" severity="secondary" (onClick)="onCancel()" />
  <p-button label="End Session" class="ms-3" (onClick)="onSubmit()" />
</div>
}
@if(step=='YesOnGuardianHandoff'){
<div class="flex justify-content-end gap-2 p-3">
  <div>
    Select person picking client up:<br>
    <p-dropdown [options]="guardians" optionLabel="Name" [(ngModel)]="guardian" placeholder="Select a guardian"
      appendTo="body" styleClass="w-100" /><br>

    <div class="mt-3" *ngIf="guardian && guardian.Name === 'Other'">
      <label for="otherGuardianName">Enter name:</label>
      <input id="otherGuardianName" type="text" pInputText [(ngModel)]="otherGuardianName" class="w-100" />
    </div>

  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="Back to session" severity="secondary" (onClick)="onCancel()" />
  <p-button label="End Session" class="ms-3" (onClick)="onAfterGuardianName()" />
</div>

}
@if(step=='afterGuardianName'){
<div class="flex justify-content-end gap-2 p-3">
  <div>
    <h5>{{guardian?.Name == 'Other' ? otherGuardianName : guardian?.Name}}</h5>
    Please enter the Guardian signature.
    <br>
    <signature-pad class="border-sign" [options]="signaturePadOptions"></signature-pad>
  </div>
</div>
<div class="flex justify-content-end gap-2 p-3">
  <p-button label="Back to session" severity="secondary" (onClick)="onCancel()" />
  <p-button label="End Session" class="ms-3" (onClick)="onSubmit()" />
</div>
}